import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize',
})
export class FileSizePipe implements PipeTransform {
  transform(bytes?: number): string {
    if (
      !bytes ||
      isNaN(+bytes) ||
      bytes.toString() === 'NaN' ||
      bytes.toString() === '0' ||
      bytes.toString() === 'undefined' ||
      bytes.toString() === 'null'
    ) {
      return '';
    }

    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(+bytes) / Math.log(1024));
    return `${parseFloat((+bytes / Math.pow(1024, i)).toFixed(1))} ${sizes[i]}`;
  }
}
